import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Items from "../../settings/Icons/Items";

const ModalSelectIcon = (props) => {
    return (
        <React.Fragment>
            <Modal isOpen={props.modal} toggle={props.toggle} className="modal-dialog-centered modal-lg" backdrop={props.backdrop}>
                {/*<ModalHeader toggle={props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {props.title}</ModalHeader>*/}
                    <ModalBody>
                        <div className="row">
                            <div className="col-md-12">
                                <Items
                                    icons={props.icons}
                                    modeEdit={props.modeEdit}
                                    setIconForm={props.setIconForm}
                                    icon_id={props.formValues.icon_id}
                                    errorValues={true}
                                />
                            </div>
                        </div>
                    </ModalBody>

                <ModalFooter>
                    <label className="btn btn-light mt-2" onClick={() => props.toggle()}>Cerrar</label>
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}


export default ModalSelectIcon;

